import React from "react";
import CaroselloStandard from "../commons/CaroselloStandard";
import bastone from "../images/Fitness/IMG_7566.jpg"
import addominali from "../images/Fitness/IMG_7562.jpg"
import grandangolo from "../images/Fitness/IMG_9229.jpg"
import sdraiati from "../images/Fitness/IMG_9237 2.jpg"
import stretching from "../images/Fitness/IMG_9232 2.jpg"
import gruppo from "../images/Fitness/IMG_9265 2.jpg"
import copertina from "../images/Fitness/foto1.jpg"
import Titolo from "../commons/Titolo";
import FitnessAccordion from "../components/fitness/FitnessAccordion";
import FitnessInfoCorsi from "../components/fitness/FitnessInfoCorsi";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import {BrowserRouter} from "react-router-dom";
import CardMultitessere from "../components/CardMultitessere";
import Space from "../commons/Space";
import TitoloSezioni from "../commons/TitoloSezioni";
import SpaceL from "../commons/SpaceL";
import CardInEvidenza from "../components/CardInEvidenza";
import estivi from "../images/Estivi/Estivi_card.jpg";
import CardNewsEvidenza from "../components/CardNewsEvidenza";
import novità from "../images/PreIscrizioni/A3.png";
import TabellaDanzaNuova from "../components/danza/TabellaDanzaNuova";
import TabellaFitnessMattino from "../components/fitness/TabellaFitnessMattino";
import TabellaFitnessNuova from "../components/fitness/TabellaFitnessNuova";
import FitAccordionPrezzi from "../components/fitness/FitAccordionPrezzi";
import {Helmet} from "react-helmet";


function Fitness() {
    return(
        <div>
            <Helmet>
                <title>Fitness</title>
                <meta name="description" content="Scopri tutti i nostri corsi fitness" />
            </Helmet>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={bastone} title={"Fitness"}/>
            <div className="d-none d-sm-block"><Space /></div>
            <div className="d-block d-sm-none"><SpaceL /></div>
            {/*
            <div className="m-auto" style={{maxWidth: "90%"}}>
                <p style={{fontSize: "32px", fontFamily: "Hammersmith One"}}>In evidenza</p>
                <hr/>
                <div className="d-none d-sm-block" >
                    <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                        <CardInEvidenza foto={estivi} titolo={"Corsi estivi 2024"} descrizione={""} data={"10.05.2024"} indirizzo={"../corsiestivi"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>
                        <CardInEvidenza foto={novità} titolo={"Novità 2024"} descrizione={""} data={"17.06.2024"} indirizzo={"../news/novità2024"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>

                    </div>
                </div>
                <div className="d-sm-none  " >
                    <div className="card-container" style={{ display:"flex", flexDirection: "row" , overflowX: "auto" }}>
                        <CardNewsEvidenza foto={estivi} titolo={"Corsi estivi 2024"} descrizione={""} data={"10.05.2024"} indirizzo={"../corsiestivi"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>
                        <CardNewsEvidenza foto={novità} titolo={"Novità 2024"} descrizione={""} data={"17.06.2024"} indirizzo={"../news/novità2024"} settore1={"piscina"} settore2={"fitness"} posizioneFoto={"top"}/>
                    </div>
                </div>
            </div>
            */}
            <SpaceL />
            <div style={{padding: "1em"}}>
            <TitoloSezioni title={"ORARI E CORSI"} />
            <SpaceL />
            <TabellaFitnessNuova />
            <FitnessInfoCorsi/>

            <SpaceL />
                <FitAccordionPrezzi />

                <Space />
                <div className="d-flex flex-column text-center align-items-center justify-content-center">
                    <TitoloSezioni title={"Multitessere"} />
                    <h4 style={{fontFamily: "Hammersmith One"}}>Scopri le nostre multitessere</h4>
                    <CardMultitessere />
                </div>

                {/*
            <TitoloSezioni title={"PREZZI"} />
            <div className="container text-center" style={{marginTop: "1em"}}>
                <div className="row align-items-start">
                    <div className="col">
                        <div style={{fontFamily: "Hammersmith One", fontSize: "20px"}}>MONOSETTIMANALE</div>
                        <strong>3 mesi</strong> 136 € + iscrizione 10 €<br/>
                        <strong>6 mesi</strong> 208 € + iscrizione 20 €<br/>
                        <strong>9 mesi</strong> 293 € + iscrizione 30 €<br/>
                    </div>
                    <div className="col align-self-center">
                        <div style={{fontFamily: "Hammersmith One", fontSize: "20px"}}>BISETTIMANALE</div>
                        <strong>3 mesi</strong> 188 € + iscrizione 10 €<br/>
                        <strong>6 mesi</strong> 299 € + iscrizione 20 €<br/>
                        <strong>9 mesi</strong> 399 € + iscrizione 30 €<br/>
                    </div>
                </div>
                <Space />
                <h2 className="d-flex flex-row justify-content-center m-auto" style={{fontFamily: "Hammersmith One"}}>Multitessera POKER</h2>
                tutti i corsi fitness di gruppo di intervallo e sera <br/>
                <strong>3 mesi</strong> 248 € + iscrizione 10 €<br/>
                <strong>6 mesi</strong> 408 € + iscrizione 20 €<br/>
                <strong>9 mesi</strong> 560 € + iscrizione 30 €<br/>
                <SpaceL />
                <div className="d-flex flex-column justify-content-center m-auto">
                    <h4 style={{fontFamily: "Hammersmith One"}}>Scopri le nostre multitessere</h4>
                    <CardMultitessere />
                </div>
            </div>
            */}

            <Space />
                <CaroselloStandard foto1={bastone} foto2={gruppo} foto3={sdraiati} foto4={grandangolo} foto5={stretching} foto6={addominali} />
            <Space />
            </div>
        </div>
    )
}


export default Fitness
